// action types
import { createRequestTypes } from "../../utils";

// Fetch MyCore Configuration
export const FETCH_MYCORE_CONFIG = createRequestTypes("FETCH_MYCORE_CONFIG");

export const fetchMycoreConfigRequest = () =>
    ({ type: FETCH_MYCORE_CONFIG.REQUEST });

export const fetchMycoreConfigSuccess = (config) =>
    ({ type: FETCH_MYCORE_CONFIG.SUCCESS, payload: { config } });

export const fetchMycoreConfigFailure = (error) =>
    ({ type: FETCH_MYCORE_CONFIG.FAILURE, payload: error });

// Update MyCore Configuration
export const UPDATE_MYCORE_CONFIG = createRequestTypes("UPDATE_MYCORE_CONFIG");

export const updateMycoreConfigRequest = (configData) =>
    ({ type: UPDATE_MYCORE_CONFIG.REQUEST, payload: { configData } });

export const updateMycoreConfigSuccess = (config) =>
    ({ type: UPDATE_MYCORE_CONFIG.SUCCESS, payload: { config } });

export const updateMycoreConfigFailure = (error) =>
    ({ type: UPDATE_MYCORE_CONFIG.FAILURE, payload: error });

// Reset MyCore Configuration
export const RESET_MYCORE_CONFIG = createRequestTypes("RESET_MYCORE_CONFIG");

export const resetMycoreConfigRequest = () =>
    ({ type: RESET_MYCORE_CONFIG.REQUEST });

export const resetMycoreConfigSuccess = (config) =>
    ({ type: RESET_MYCORE_CONFIG.SUCCESS, payload: { config } });

export const resetMycoreConfigFailure = (error) =>
    ({ type: RESET_MYCORE_CONFIG.FAILURE, payload: error });
